import axios from "axios"
import store from "../redux/store"
import { showToastAction } from "../redux/toastSlice"

export default async function newProject({ project_name, description }) {
    try {
        await axios.post("/new-project",
            { project_name, description })
        store.dispatch(showToastAction({ message: "Project created", showToast: true, severity: "success" }))
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}